import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Известные ответы бэкенда на регистрацию: поле формы → текст сервера → сообщение пользователю. */
const SIGN_UP_ERROR_MESSAGES: Record<string, Record<string, MessageDescriptor>> = {
  phone: {
    'This value is already used.': msg`Указанный номер уже используется`,
  },
};

/** Неизвестный ответ — `undefined`: форма показывает текст сервера как пришёл. */
export function getSignUpErrorMessage(field: string, serverMessage: string): MessageDescriptor | undefined {
  return SIGN_UP_ERROR_MESSAGES[field]?.[serverMessage];
}
